import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "form",
    "firstName",
    "lastName",
    "dateOfBirth",
    "gender",
    "ssn",
  ];
  static values = {
    url: String,
  };

  connect() {
    this.timeout = null;
    this.debounceDelay = 300; // milliseconds
  }

  search() {
    // Clear existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    // Debounce the search
    this.timeout = setTimeout(() => {
      this.performSearch();
    }, this.debounceDelay);
  }

  performSearch() {
    const formData = new FormData();

    // Add search parameters if they have values
    if (this.hasFirstNameTarget && this.firstNameTarget.value) {
      formData.append("first_name", this.firstNameTarget.value);
    }

    if (this.hasLastNameTarget && this.lastNameTarget.value) {
      formData.append("last_name", this.lastNameTarget.value);
    }

    if (this.hasDateOfBirthTarget && this.dateOfBirthTarget.value) {
      formData.append("date_of_birth", this.dateOfBirthTarget.value);
    }

    if (this.hasGenderTarget && this.genderTarget.value) {
      formData.append("gender", this.genderTarget.value);
    }

    if (this.hasSsnTarget && this.ssnTarget.value) {
      formData.append("ssn", this.ssnTarget.value);
    }

    // Only search if at least one field has a value
    const hasSearchCriteria = Array.from(formData.values()).some(
      (value) => value !== "",
    );

    if (!hasSearchCriteria) {
      return;
    }

    // Submit via fetch to the search endpoint
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
        Accept: "text/vnd.turbo-stream.html",
      },
      body: formData,
    })
      .then((response) => response.text())
      .then((html) => {
        // Turbo will automatically handle the stream response
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => {
        console.error("Search error:", error);
      });
  }
}
